import { render } from "./Notepad.vue?vue&type=template&id=21fb4d4a&scoped=true"
import script from "./Notepad.vue?vue&type=script&lang=js"
export * from "./Notepad.vue?vue&type=script&lang=js"

import "./Notepad.vue?vue&type=style&index=0&id=21fb4d4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21fb4d4a"]])

export default __exports__